import { createArrayFromObject } from "../../../../Utilities/Types/arrayUtilities";

export const buttonIconType = {
    ADD: "buttonIcon--add",
    ADD_OPTION: "buttonIcon--addOption",
    APPROVE: "buttonIcon--approve",
    BARCODE: "buttonIcon--barcode",
    CANCEL: "buttonIcon--cancel",
    CERTIFICATE: "buttonIcon--certificate",
    COPY_CLIPBOARD: "buttonIcon--copyClipboard",
    COPY_COMPONENT: "buttonIcon--copyComponent",
    CLEAR: "buttonIcon--clear",
	CONTENT: "buttonIcon--content",
	DELETE: "buttonIcon--delete",
	DELETE_COMPONENT: "buttonIcon--deleteComponent",
    DOWNLOAD_FOLLOWUP: "buttonIcon--downloadFollowup",
    EDIT: "buttonIcon--edit",
    DONE_EDITING: "buttonIcon--doneEditing",
    EXIT: "buttonIcon--exit",
    ENROLLMENTS: "buttonIcon--enrollments",
    IMPERSONATE: "buttonIcon--impersonate",
    MENU: "buttonIcon--menu",
    MODULES: "buttonIcon--modules",
    NEW_WINDOW: "buttonIcon--newWindow",
    ORDER: "buttonIcon--order",
    PACKING_LIST: "buttonIcon--packingList",
    PRINT: "buttonIcon--print",
	PROFILE: "buttonIcon--profile",
	REMOVE: "buttonIcon--remove",
    REPAIR_DETAILS: "buttonIcon--repairDetails",
	SAVE: "buttonIcon--save",
	SEARCH: "buttonIcon--search",
    UPLOAD: "buttonIcon--upload",
    HISTORY: "buttonIcon--history",
    VIEW: "buttonIcon--view",
    PROGRESS: "buttonIcon--progress",
}

export const buttonIconTypeList = createArrayFromObject(buttonIconType);
